import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _phoneLengths;
// Constants
import countries from "./countries";
var phoneFormatterSpecs = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, countries.AU, [{
  "char": /[1-9]/,
  repeat: 1
}, {
  "char": /\d/,
  repeat: 3
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 3
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 3
}]), countries.AT, [{
  "char": /[1-9]/,
  repeat: 1
}, {
  "char": /\d/,
  repeat: 2
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 3
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 5
}]), countries.DE, [{
  "char": /[1-9]/,
  repeat: 1
}, {
  "char": /\d/,
  repeat: 2
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 8
}]), countries.NL, [{
  "char": /[1-9]/,
  repeat: 1
}, {
  "char": /\d/,
  repeat: 1
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 4
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 3
}]), countries.EN, [{
  "char": /[1-9]/,
  repeat: 1
}, {
  "char": /\d/,
  repeat: 1
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 4
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 4
}]), countries.ES, [{
  "char": /[1-9]/,
  repeat: 1
}, {
  "char": /\d/,
  repeat: 2
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 3
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 3
}]), countries.CA, [{
  "char": /[1-9]/,
  repeat: 1
}, {
  "char": /\d/,
  repeat: 2
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 3
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 4
}]), countries.US, [{
  "char": /[1-9]/,
  repeat: 1
}, {
  "char": /\d/,
  repeat: 2
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 3
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 4
}]), countries.GB, [{
  "char": /[1-9]/,
  repeat: 1
}, {
  "char": /\d/,
  repeat: 1
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 4
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 4
}]), 'default', [{
  "char": /[1-9]/,
  repeat: 1
}, {
  "char": /\d/,
  repeat: 2
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 3
}, {
  exactly: ' '
}, {
  exactly: '-'
}, {
  exactly: ' '
}, {
  "char": /\d/,
  repeat: 3
}]);
var phoneLengths = (_phoneLengths = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.AT, [10, 11]), countries.NL, 9), countries.EN, 10), countries.ES, 9), countries.DE, [10, 11]), countries.CA, 10), countries.US, 10), countries.AU, 10), countries.GB, 10), countries.BS, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.BB, 9), countries.AI, 9), countries.AG, 9), countries.KY, 9), countries.BM, 9), countries.GD, 9), countries.MP, 9), countries.GU, 9), countries.AS, 9), countries.LC, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.DM, 9), countries.VC, 9), countries.PR, 9), countries.DO, 9), countries.TT, 9), countries.KN, 9), countries.JM, 9), countries.EG, 9), countries.SS, 9), countries.MA, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.DZ, 9), countries.TN, 9), countries.LY, 9), countries.GM, 9), countries.SN, 9), countries.MR, 9), countries.ML, 9), countries.GN, 9), countries.CI, 9), countries.BF, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.NE, 9), countries.TG, 9), countries.BJ, 9), countries.MU, 9), countries.LR, 9), countries.SL, 9), countries.GH, 9), countries.NG, 9), countries.TD, 9), countries.CF, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.CM, 9), countries.CV, 9), countries.ST, 9), countries.GQ, 9), countries.GA, 9), countries.CG, 9), countries.CD, 9), countries.AO, 9), countries.GW, 9), countries.SC, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.SD, 9), countries.RW, 9), countries.ET, 9), countries.SO, 9), countries.DJ, 9), countries.KE, 9), countries.TZ, 9), countries.UG, 9), countries.BI, 9), countries.MZ, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.MG, 9), countries.NA, 9), countries.MW, 9), countries.LS, 9), countries.BW, 9), countries.SZ, 9), countries.KM, 9), countries.ZA, 9), countries.ER, 9), countries.AW, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.GL, 9), countries.GR, 9), countries.BE, 9), countries.FR, 9), countries.PT, 9), countries.LU, 9), countries.IE, 9), countries.AL, 9), countries.MT, 9), countries.CY, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.FI, 9), countries.BG, 9), countries.HU, 9), countries.LT, 9), countries.LV, 9), countries.EE, 9), countries.MD, 9), countries.AM, 9), countries.BY, 9), countries.AD, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.MC, 9), countries.SM, 9), countries.UA, 9), countries.RS, 9), countries.ME, 9), countries.XK, 9), countries.HR, 9), countries.SI, 9), countries.BA, 9), countries.IT, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.VA, 9), countries.RO, 9), countries.CH, 9), countries.CZ, 9), countries.SK, 9), countries.LI, 9), countries.DK, 9), countries.SE, 9), countries.NO, 9), countries.PL, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.BZ, 9), countries.GT, 9), countries.SV, 9), countries.HN, 9), countries.NI, 9), countries.CR, 9), countries.PA, 9), countries.HT, 9), countries.PE, 9), countries.MX, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.CU, 9), countries.AR, 9), countries.BR, 9), countries.CL, 9), countries.CO, 9), countries.VE, 9), countries.BO, 9), countries.GY, 9), countries.EC, 9), countries.PY, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.SR, 9), countries.UY, 9), countries.MY, 9), countries.CX, 9), countries.CC, 9), countries.ID, 9), countries.PH, 9), countries.NZ, 9), countries.SG, 9), countries.TH, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.TL, 9), countries.NF, 9), countries.BN, 9), countries.NR, 9), countries.PG, 9), countries.TO, 9), countries.SB, 9), countries.VU, 9), countries.FJ, 9), countries.PW, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.CK, 9), countries.NU, 9), countries.WS, 9), countries.KI, 9), countries.NC, 9), countries.TV, 9), countries.FM, 9), countries.MH, 9), countries.KZ, 9), countries.RU, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.JP, 9), countries.KR, 9), countries.KP, 9), countries.HK, 9), countries.MO, 9), countries.KH, 9), countries.LA, 9), countries.CN, 9), countries.BD, 9), countries.TW, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.TR, 9), countries.IN, 9), countries.PK, 9), countries.AF, 9), countries.LK, 9), countries.MM, 9), countries.MV, 9), countries.LB, 9), countries.JO, 9), countries.SY, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.IQ, 9), countries.KW, 9), countries.SA, 9), countries.OM, 9), countries.AE, 9), countries.IL, 9), countries.BH, 9), countries.QA, 9), countries.BT, 9), countries.MN, 9), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_phoneLengths, countries.NP, 9), countries.IR, 9), countries.TJ, 9), countries.TM, 9), countries.AZ, 9), countries.GE, 9), countries.KG, 9), countries.UZ, 9), 'default', 9));
export default {
  phoneFormatterSpecs: phoneFormatterSpecs,
  phoneLengths: phoneLengths
};